export default "__VITE_ASSET__Dvar$PQg__"